import { Card, Col, DatePicker, Form, Input, InputNumber, Row } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { getRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";

import "../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../utils/Notifications";

import logo from "../../image/heycourierLogo.png";
import moment from "moment";
const AddMoneyModelAdmin = ({
  handleCancel,
  // setReload,
  walletId,
  companyId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm(); // Antd Form instance
  const rechargeInputRef = useRef(null);
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const initialState = {
    invoice_date: moment(), // Moment object (for DatePicker)
    // due_date: moment().add(7, "days"),
    recharge_amount: null,
    billed_by_legal_name: "The Big Box Group Pty Ltd",
    billed_by_business_name: "T/a Hey Couriers Pty Ltd",
    billed_by_address: "Unit 3 / 25 Loyalty Rd, NorthRocks -2151, NSW",
    billed_by_abn: "73 839 044 005",
    billed_by_email: "admin@thebigboxgroup.com.au",
    invoice_to_name: null,
    invoice_to_address_line: null,

    note: "Recharge Added",

    total_recharge_amount: null,
    account_no: "13509079",
    bank_state_branch: "062443",
  };
  const [state, setState] = useState(initialState);

  const [btnLoading, setBtnLoading] = useState(false);

  const [subtotal, setSubtotal] = useState(0);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });
  useEffect(() => {
    if (modalKey) {
      setTimeout(() => {
        rechargeInputRef.current?.focus();
      }, 200); // Slight delay to ensure component is rendered
    }
  }, [modalKey]);
  useEffect(() => {
    const employeeGetById = async () => {
      // setapiloading(true);
      try {
        const apiResponse = await getRequest(`company/${companyId}`);
        console.log("apiResponse", apiResponse);
        if (apiResponse.data.success) {
          console.log("apiResponse", apiResponse);
          const {
            company,

            ...filteredResponse
          } = apiResponse.data.data;

          setState({
            // ...apiResponse.data.data,

            ...initialState,
            invoice_to_name: apiResponse.data.data.company_name,
            invoice_to_address_line:
              apiResponse.data.data.company_street_address,
            // invoice_payment_interval:
            //   apiResponse.data.data.invoice_payment_interval,

            // recharge_amount: apiResponse.data.data.recharge_amount,
            // total_recharge_amount: apiResponse.data.data.total_recharge_amount,
          });
          // setSubtotal(apiResponse.data.data.total_recharge_amount);
          form.setFieldsValue({
            ...apiResponse.data.data,
            invoice_to_name: apiResponse.data.data.company_name,
            invoice_to_address_line:
              apiResponse.data.data.company_street_address,

            // recharge_amount: apiResponse.data.data.recharge_amount,
            // total_recharge_amount: apiResponse.data.data.total_recharge_amount,
          });

          // setapiloading(false);
        }
      } catch (error) {
        // ErrorNotificationMsg(t("Error while fetching invoice data"));
        // setapiloading(false);
      }
    };
    if (walletId !== null) {
      employeeGetById();
    }
  }, [walletId, modalKey, t]);
  // const handleRechargeValueChange = () => {
  //   const rechargeAmount = form.getFieldValue("recharge_amount") || 0;

  //   setState((prevState) => ({
  //     ...prevState,
  //     recharge_amount: rechargeAmount,
  //     total_recharge_amount: rechargeAmount,
  //   }));

  //   setSubtotal(rechargeAmount);
  // };
  const handleRechargeValueChange = (value) => {
    const rechargeAmount =
      typeof value === "number" && !isNaN(value) ? value : 0;

    setState((prevState) => ({
      ...prevState,
      recharge_amount: rechargeAmount,
      total_recharge_amount: rechargeAmount,
    }));

    setSubtotal(rechargeAmount);
  };

  const handleDatepickerChange = (date, name) => {
    const formattedDate = moment(date).format("DD-MM-YYYY");
    console.log("formattedDate", formattedDate);
    if (formattedDate !== "Invalid date") {
      setState((prev) => ({ ...prev, [name]: formattedDate }));
    } else {
      setState((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleRedirectStripePage = (response) => {
    if (CompanyId) {
      window.open(response.data.payment_link, "_blank");
    }
  };
  const backToList = () => {
    setSubtotal(0);
    form.setFieldsValue({
      recharge_amount: null,
    });
    handleCancel();
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      const payload = {
        ...state,
        company: companyId,
        invoice_date: moment(state.invoice_date).format("DD-MM-YYYY"),
      };
      if (walletId !== null) {
        response = await postRequest(
          `invoice/prepaid-wallet-recharge/`,
          payload
        );
      }
      // else {
      //   response = await patchRequest(`state/${walletId}/`, state);
      // }
      if (response.data.success) {
        SuccessNotificationMsg(t("Invoice sent to the company's mail"));

        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));
        form.setFieldsValue(initialState);

        setBtnLoading(false);
        handleCancel();
        // setReload((reload) => !reload);
        setTimeout(() => {
          handleRedirectStripePage(response);
        }, 1500);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <section className="grid-sec FormSection Container InvoiceSec">
        <div className="FormBody" style={{ padding: "0" }}>
          <Form
            form={form}
            layout="vertical"
            initialValues={{ ...state }}
            onFinish={handleSubmit}
            autoComplete="off"
          >
            <div className="modalscrolldiv">
              {/* Logo & Company Info */}
              <div
                className="invoice-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  marginBottom: 24,
                }}
              >
                <div>
                  <img
                    src={logo}
                    alt="Hey Couriers Logo"
                    style={{ height: 60 }}
                  />
                </div>
                <div style={{ textAlign: "right", fontSize: 14 }}>
                  <b>THE BIG BOX GROUP PTY LTD T/A HEY COURIERS PTY LTD</b>
                  <br />
                  <b>ABN:</b> 73 839 044 005
                  <br />
                  admin@thebigboxgroup.com.au
                </div>
              </div>

              {/* Invoice Number + Dates */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 16,
                  marginBottom: 24,
                }}
              >
                <Form.Item name="invoice_number" label="Invoice Number">
                  <Input disabled />
                </Form.Item>
                <Form.Item name="invoice_date" label="Invoice Date">
                  <DatePicker
                    name="invoice_date"
                    onChange={(date) =>
                      handleDatepickerChange(date, "invoice_date")
                    }
                    format="DD-MM-YYYY"
                  />
                </Form.Item>
                {/* <Form.Item name="due_date" label="Due Date">
                  <DatePicker
                    format="DD-MM-YYYY"
                    name="due_date"
                    disabledDate={(current) =>
                      current && current < moment().startOf("day")
                    }
                    onChange={(date) =>
                      handleDatepickerChange(date, "due_date")
                    }
                  />
                </Form.Item> */}
              </div>

              {/* From / To Info */}
              <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={12}>
                  <Card bordered>
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        padding: 8,
                        fontWeight: 600,
                      }}
                    >
                      Invoice From
                    </div>
                    <div style={{ padding: 12 }}>
                      The Big Box Group Pty Ltd
                      <br />
                      T/a Hey Couriers Pty Ltd
                      <br />
                      Unit 3 / 25 Loyalty Rd,
                      <br />
                      NorthRocks -2151, NSW
                      <br />
                      <b>ABN:</b> 73 839 044 005
                    </div>
                  </Card>
                </Col>
                <Col span={12}>
                  <Card bordered>
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        padding: 8,
                        fontWeight: 600,
                      }}
                    >
                      Invoice To
                    </div>
                    <div style={{ padding: 12 }}>
                      {state?.invoice_to_name}
                      <br />
                      {state?.invoice_to_address_line
                        ?.split(",")
                        .map((line, index) => (
                          <React.Fragment key={index}>
                            {line.trim()}
                            <br />
                          </React.Fragment>
                        ))}
                    </div>
                  </Card>
                </Col>
              </Row>

              {/* Recharge Table */}
              <Card bordered style={{ marginBottom: 24 }}>
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr style={{ background: "#f5f5f5", fontWeight: "bold" }}>
                        <th style={{ padding: 10, border: "1px solid #ddd" }}>
                          Note
                        </th>
                        <th style={{ padding: 10, border: "1px solid #ddd" }}>
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ padding: 10, border: "1px solid #ddd" }}>
                          Recharge Added
                        </td>
                        <td style={{ padding: 10, border: "1px solid #ddd" }}>
                          {/* <Form.Item name="recharge_amount" noStyle>
                            <InputNumber
                              min={0}
                              step={0.01}
                              precision={2}
                              style={{ width: "100%" }}
                              parser={(value) => value.replace(/[^\d.]/g, "")}
                              formatter={(value) =>
                                value?.replace(/[^\d.]/g, "")
                              }
                              onKeyPress={(e) => {
                                const allowedChars = /[0-9.]/;
                                if (!allowedChars.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              controls={false}
                              onChange={handleRechargeValueChange}
                            />
                          </Form.Item> */}
                          <Form.Item name="recharge_amount" noStyle>
                            <InputNumber
                              ref={rechargeInputRef}
                              min={0}
                              step={0.01}
                              precision={2}
                              style={{
                                width: "100%",
                                border: "2px solid #faad14",
                                backgroundColor: "#fffbe6",
                                fontWeight: 600,
                                outline: "none",
                              }}
                              placeholder="Enter Amount"
                              parser={(value) => value.replace(/[^\d.]/g, "")}
                              formatter={(value) =>
                                value?.replace(/[^\d.]/g, "")
                              }
                              onKeyPress={(e) => {
                                const allowedChars = /[0-9.]/;
                                if (!allowedChars.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              controls={false}
                              onChange={handleRechargeValueChange}
                            />
                          </Form.Item>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </Card>

              {/* Total Recharge Summary */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: 24,
                }}
              >
                <div style={{ width: 300, marginTop: 20 }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "6px 0",
                      fontWeight: 600,
                    }}
                  >
                    <span>Total Recharge</span>
                    <span>${subtotal?.toFixed(2)}</span>
                  </div>
                </div>
              </div>

              {/* Bank Info */}
              <Card>
                <Row>
                  <Col span={12}>
                    <div style={{ fontWeight: 600, paddingBottom: 8 }}>
                      BANK INFO
                    </div>
                    <div>
                      <b>THE BIG BOX GROUP PTY LTD</b>
                      <br />
                      Account No: <b>13509079</b>
                      <br />
                      BSB: <b>062443</b>
                    </div>
                  </Col>
                  <Col
                    span={12}
                    style={{ textAlign: "right", alignSelf: "center" }}
                  >
                    <h3 style={{ color: "orange", marginTop: 0 }}>
                      Thank You!
                    </h3>
                  </Col>
                </Row>
              </Card>
            </div>

            {/* Footer Buttons */}
            <div className="ModalPopupFooter">
              <ButtonField
                className="CancelGradiantBtn"
                type="primary"
                htmlType="button"
                label={t("cancel")}
                onClick={backToList}
              />
              <ButtonField
                className="SaveGradiantBtn"
                type="primary"
                htmlType="Submit"
                label={t("Add")}
                loading={btnLoading}
              />
            </div>
          </Form>
        </div>
      </section>
    </>
  );
};

AddMoneyModelAdmin.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  // setReload: PropTypes.func.isRequired,
  walletId: PropTypes.number,
  companyId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired,
};

export default AddMoneyModelAdmin;
